const BUCKETS = [[0, "Vence hoje", "bg-amber-100 text-amber-900"], [3, "Vence em 3 dias", "bg-amber-50 text-amber-800"], [7, "Vence em 7 dias", "bg-sky-50 text-sky-800"],
  [15, "Vence em 15 dias", "bg-slate-100 text-slate-700"], [30, "Vence em 30 dias", "bg-slate-50 text-slate-600"]];

export const daysText = (d) => (d < 0 ? `Vencido há ${-d} dia${d < -1 ? "s" : ""}` : d === 0 ? "Vence hoje" : `Faltam ${d} dia${d > 1 ? "s" : ""}`);

export function ProxBadge({ days, testid }) {
  if (days === null || days === undefined || days < 0) return null;
  const b = BUCKETS.find(([n]) => days <= n);
  return b ? <span className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold ${b[2]}`} data-testid={testid}>{b[1]}</span> : null;
}
